/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/revokeToken';


// ---------------- Saga's response ----------------
function fetchRevokeTokenSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.error= false;
}

function fetchRevokeTokenError(state) {
  state.response = [];
  state.error = true;
}


const fetchRevokeToken = createAction('fetchRevokeToken');

// ------------- connection ------------- //

const revokeTokenReducer = createSlice({
  name: 'RevokeToken',
  initialState,
  reducers: {
    fetchRevokeTokenSuccess,
    fetchRevokeTokenError,
  },
});

export const revokeTokenAction = {
  ...revokeTokenReducer.actions,
  fetchRevokeToken,
};

export default revokeTokenReducer.reducer;